import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { rolesQueries } from '@/services/rolesPrivilege/roles.queries';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useRoleMutation = () => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation('createRole', {
    onSuccess: async (res) => {
      toast.success(res.message);
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [...rolesQueries.all()],
        }),
        queryClient.invalidateQueries({
          predicate: ({ queryKey }) => {
            const dropdownParams = queryKey[1];
            return (
              queryKey[0] === 'dropdown' &&
              typeof dropdownParams === 'object' &&
              dropdownParams !== null &&
              'flag' in dropdownParams &&
              dropdownParams.flag === 'roleType'
            );
          },
        }),
      ]);
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });
  return { mutateAsync };
};
